import * as chains from '../model/chain';
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function getChainMeta(chainId) {
  var chain = Object.values(chains).find(function (chain) {
    return chain.chainId === chainId;
  });
  if (!chain) {
    throw new Error("Chain ".concat(chainId, " does not exist"));
  }
  return chain;
}